import { Component } from "@angular/core";

@Component({
  selector: "app-child-entity-add-list-dialog",
  templateUrl: "./child-entity-add-list-dialog.component.html",
  styleUrls: ["./child-entity-add-list-dialog.component.css"]
})
export class ChildEntityAddListDialogComponent {
  constructor() {}
}
